import _ from 'lodash';
function isContactRuleGroupEqual(value, other) {
    return _.isEqual(value.name, other.name) && _.isEqual(value.rules, other.rules);
}
export default isContactRuleGroupEqual;
